// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../Kontent/Kontent.bs.js";

var container = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center")
    ]);

var country = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.flexGrow(1),
      BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(10))
    ]);

var flag = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(38)),
      BsCssJs$PrezzeeRibbon.borderColor("transparent"),
      BsCssJs$PrezzeeRibbon.borderWidth(BsCssJs$PrezzeeRibbon.px(1)),
      BsCssJs$PrezzeeRibbon.borderStyle("solid")
    ]);

var Styles = {
  container: container,
  country: country,
  flag: flag
};

function RegionListLineContent(props) {
  var name = props.name;
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                            className: flag,
                            alt: name,
                            src: props.flag
                          }),
                      JsxRuntime.jsx("div", {
                            children: name,
                            className: country
                          }),
                      JsxRuntime.jsx("div", {
                            children: props.currency
                          })
                    ],
                    className: container
                  })
            });
}

var make = RegionListLineContent;

export {
  Styles ,
  make ,
}
/* container Not a pure module */
